/* eslint-disable no-console */
import { useEffect, useState } from 'react';

export const hasIntersectionObserver = () => 'IntersectionObserver' in window;

export const useSupportsIntersectionObserver = ({ defaultValue = false } = {}) => {
	const [supports, setSupports] = useState(defaultValue);

	useEffect(() => {
		setSupports(hasIntersectionObserver());
	}, []);

	return supports;
};

const useIntersectionObserver = ({ onIntersect, root, rootMargin = '0px', target, threshold = 1.0 }) => {
	const isTargetSet = !!target.current;

	useEffect(() => {
		const supports = hasIntersectionObserver();

		if (!supports) {
			return undefined;
		}

		const rootRef = root?.current;
		const targetRef = target?.current;

		const observer = new IntersectionObserver(onIntersect, {
			root: rootRef,
			rootMargin,
			threshold,
		});

		if (!targetRef) {
			console.warn('No target specified for Intersection Observer.');

			return undefined;
		}

		observer.observe(targetRef);

		return () => {
			observer?.disconnect(targetRef);
		};
	}, [onIntersect, root, rootMargin, target, threshold, isTargetSet]);
};

export default useIntersectionObserver;
